import habitat from 'preact-habitat/src/index';

import importComponent from './lib/importComponent';

const JobsHabitat = habitat(importComponent(async () =>
  (await import('./components/jobs')).default));

JobsHabitat.render({
  selector: '.fu-embed-jobs',
  clean: true,
});

const NewsHabitat = habitat(importComponent(async () =>
  (await import('./components/news')).default));

NewsHabitat.render({
  selector: '.fu-news-embed',
  clean: true,
});


const ProductsHabitat = habitat(importComponent(async () =>
  (await import('./components/products')).default));

ProductsHabitat.render({
  selector: '.fu-products-embed',
  clean: true,
});
